import { render, staticRenderFns } from "./WorkflowBrandSettingCustomFontModal.vue?vue&type=template&id=2a453a43&scoped=true"
import script from "./WorkflowBrandSettingCustomFontModal.vue?vue&type=script&lang=js"
export * from "./WorkflowBrandSettingCustomFontModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowBrandSettingCustomFontModal.vue?vue&type=style&index=0&id=2a453a43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a453a43",
  null
  
)

export default component.exports